<template>
  <div id="productAddOnContainer">
    <div>
      <div class="d-flex" id="productAddOnRow">
        <div class="left-panel">
          <div id="productAddOnOptionHeaderRow" class="row mt-2">
            <div id="productAddOnOptionHeaderCol" class="col-md-10 col-sm-9">
              <h5 id="productAddOnOptionHeader" class="font-weight-normal mb-3">
                {{ $t('txtOptionCategory') }}
              </h5>
            </div>
          </div>
          <table id="productBOMItemsWrapper" class="table table-hover text-dark">
            <tbody>
              <div class="con-add  " style="overflow-y: auto; ">
                <CRow style=" width: 100%" id="productBOMItemsRow" v-for="(item, index) in optionGroupList"
                  :key="index">
                  <CCol :id="'productBOMItemsCol' + index" col="12" lg="12">
                    <div class="option-card cursor" 
                      :class="{ 'disabled-card': item.items.length === 0 }"
                      @click="isEditData && item.items.length > 0 && onCheckboxChange(item, index)">
                      <div class="option-header d-flex justify-content-between">
                        <div>
                          <strong class="text-dark">{{ item.name }}</strong>
                        </div>

                        <div v-if="isEditData">
                          <img :id="'productAddOnOptionGroupActionIcon' + index" style="width: 20px;"
                            :title="item.items.length > 0 ? '' : $t('noOptionToSelect')"
                            src="/img/flat-color-icons--plus.png" v-show="isEditData" />
                        </div>
                      </div>
                      <div :id="'productAddOnOptionGroupDetailsRow' + index" class="row">
                        <div class="col-10 text-dark font-weight-normal" :id="'productAddOnOptionGroupDetails' + index"
                          style="width: 70%; margin-bottom: 0rem;">
                          <small class="text-muted 1" v-if="item.require">{{ $t('require') }} (<span
                              :id="'productAddOnOptionGroupMinBadge' + index" color="primary"
                              v-if="item.minimum !== undefined && item.minimum !== null" class="">
                              {{$t('minimum')}} : <span>{{ item.minimum }}</span>
                            </span>,<span :id="'productAddOnOptionGroupMaxBadge' + index" color="info"
                              v-if="item.maximum !== undefined && item.maximum !== null">
                              {{$t('maximumChioce')}} : <span>{{ item.maximum }}</span>
                            </span> <span :id="'productAddOnOptionGroupMaxBadge' + index" color="info"
                              v-if="item.maximum == null|| item.maximum === 0">
                              {{$t('unlimited')}}
                            </span>)</small>

                            <small class="text-muted " v-else>{{ $t('optional') }} (<span
                              :id="'productAddOnOptionGroupMinBadge' + index" color="primary"
                              v-if="item.minimum !== undefined && item.minimum !== null" class="">
                              {{$t('minimum')}} : <span>{{ item.minimum }} ,</span>
                            </span><span :id="'productAddOnOptionGroupMaxBadge' + index" color="info"
                              v-if="item.maximum !== undefined && item.maximum !== null">
                              {{$t('maximumChioce')}} : <span>{{ item.maximum }}</span>
                            </span> <span :id="'productAddOnOptionGroupMaxBadge' + index" color="info"
                              v-if="item.maximum == null">
                              {{$t('unlimited')}}
                            </span>)</small>
                          <!-- <CBadge :id="'productAddOnGroupRequiredBadge' + index" class="mr-1" color="success"
                            v-if="item.require">
                            {{ $t('require') }}
                          </CBadge>
                          <CBadge :id="'productAddOnOptionGroupMinBadge' + index" color="primary"
                            v-if="item.minimum !== undefined && item.minimum !== null" class="mr-1">
                            อย่างน้อย : <span>{{ item.minimum }}</span>
                          </CBadge>
                          <CBadge :id="'productAddOnOptionGroupMaxBadge' + index" color="info"
                            v-if="item.maximum !== undefined && item.maximum !== null">
                            สูงสุด : <span>{{ item.maximum }}</span>
                          </CBadge> -->
                        </div>
                        <div :id="'productAddOnOptionGroupTotals' + index"
                          class="col text-right text-dark font-weight-normal pl-0" style="margin-bottom: 0rem;">
                          <CBadge :id="'productAddOnActiveGroupRequiredBadge'+ index"    color="dark" >
                               {{ $t('totals') }} {{ item.items.length }}
                            </CBadge> 
                        </div>
                      </div>
                      <hr id="productAddOnOptionGroupDivider" class="hr-card-option" />
                      <div :id="'productAddOnOptionGroupItemsRow' + index" class="option-items">
                        <div v-for="(subItem, subIndex) in item.items" :key="subIndex"
                          class="d-flex justify-content-between text-muted p-s">
                          <span :id="'productAddOnOptionGroupItemName' + subIndex"
                            class="p-s text-dark font-weight-normal m-0"> {{ subItem.optionItem.name }}</span>
                          <span :id="'productAddOnOptionGroupItemPrice' + subIndex"
                            class="p-s text-dark font-weight-normal m-0">{{ subItem.optionItem.price }}</span>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </div>
            </tbody>
          </table>

        </div>
        <div id="productAddOnActiveCol" class="right-panel">
          <div id="productAddOnActiveHeaderRow" class="row mt-2">
            <div id="productAddOnActiveHeaderCol" class="col-md-10 col-sm-9">
              <h5 id="productAddOnActiveHeader" class="font-weight-normal mb-3">
                {{ $t('addOnActive') }} 
                <CBadge :id="'productAddOnActiveGroupRequiredBadge'"    color="success" >
                    {{ $t('totals') }} {{ activeGroup.length }}
                </CBadge> 
              </h5>
            </div>
          </div>
          <table class="table table-hover">
            <tbody>
              <div  >
                <VueDraggable
                  v-model="optionGroupActive"
                  @end="onDragEnd"
                  @start="handleDragStart"
                  @move="handleAutoScroll"
                  @dragend="stopAutoScroll"
                  ref="draggable"
                  style="overflow-y: auto; " class="con-add "
                  :delay="dragDelay"
                >
                  <CRow id="productAddOnActiveGroupRow" v-for="(item, index) in activeGroup" :key="index"
                    style=" width: 100%">
                    <!-- <CCol> <span class="drag-handle text-dark" style="cursor: grab;font-size: 20px;">☰</span> </CCol> -->
                    <CCol :id="'productAddOnActiveGroupCol' + index" col="12" lg="12">
                      <div class="option-card cursor">
                        <div class="option-header d-flex justify-content-between">
                          <div>
                            <span class="drag-handle text-dark" style="cursor: grab;font-size: 20px;">☰</span>  <strong class="text-dark">{{ item.groupActiveName }}</strong>

                          </div>
                          <div v-if="isDeleteData">
                            <img :id="'productAddOnActiveGroupActionIcon' + index" src="/img/product/delete32.png"
                              style="width: 25px;" v-if="isDeleteData" @click="confirmdeleteOptionGroup(item)"
                              v-show="isEditData" />
                          </div>
                        </div>
                        <div :id="'productAddOnOptionGroupDetailsRow' + index" class="row">
                          <div class="col-10 text-dark font-weight-normal" :id="'productAddOnActiveGroupDetails' + index"
                            style="width: 70%; margin-bottom: 0rem;">
                            <small class="text-muted " v-if="item.require">{{ $t('require') }} (<span
                                :id="'productAddOnOptionGroupActiveMinBadge' + index" color="primary"
                                v-if="item.minimum !== undefined && item.minimum !== null" >
                                {{$t('minimum')}} : <span>{{ item.minimum }}</span>
                              </span>,<span :id="'productAddOnOptionGroupMaxActiveBadge' + index" color="info"
                                v-if="item.maximum !== undefined && item.maximum !== null && item.maximum !== 0">
                                {{$t('maximumChioce')}} : <span>{{ item.maximum }}</span>
                              </span> <span :id="'productAddOnOptionGroupMaxActiveBadge' + index" color="info"
                                v-if="item.maximum == null|| item.maximum === 0">
                                {{$t('unlimited')}}
                              </span>)</small>

                              <small class="text-muted " v-else>{{ $t('optional') }} (<span
                                :id="'productAddOnOptionGroupActiveMinBadge' + index" color="primary"
                                v-if="item.minimum !== undefined && item.minimum !== null" >
                                {{$t('minimum')}} : <span>{{ item.minimum }} ,</span>
                              </span><span :id="'productAddOnOptionGroupActiveMaxBadge' + index" color="info"
                                v-if="item.maximum !== undefined && item.maximum !== null&& item.maximum !== 0">
                                {{$t('maximumChioce')}} : <span>{{ item.maximum }}</span>
                              </span> <span :id="'productAddOnOptionGroupActiveMaxBadge' + index" color="info"
                                v-if="item.maximum == null">
                                {{$t('unlimited')}}
                              </span>)</small>
                            <!-- <CBadge :id="'productAddOnActiveGroupRequiredBadge'+ index"  class="mr-1"  color="success" v-if="item.require">
                                      Required
                              </CBadge>
                              <CBadge :id="'productAddOnActiveGroupMinBadge' + index" color="primary"
                                v-if="item.minimum !== undefined && item.minimum !== null" class="mr-1">
                                Min : <span>{{ item.minimum }}</span>
                              </CBadge>
                              <CBadge :id="'productAddOnActiveGroupMaxBadge' + index" color="info"
                                v-if="item.maximum !== undefined && item.maximum !== null">
                                Max : <span>{{ item.maximum }}</span>
                              </CBadge> -->
                          </div>
                          <div :id="'productAddOnActiveGroupTotals' + index"
                            class="col text-right text-dark font-weight-normal pl-0" style="margin-bottom: 0rem;">
                            <!-- <small class="p-s text-right">  -->
                              <CBadge :id="'productAddOnActiveGroupRequiredBadge'+ index"    color="dark" >
                                {{ $t('totals') }} {{ item.items.length }}
                              </CBadge> 
                              <!-- {{ $t('totals') }} ({{ item.items.length }})  -->
                            <!-- </small> -->
                          </div>
                        </div>
                        <hr id="productAddOnActiveGroupDivider" class="hr-card-option" />
                        <div class="option-items" :id="'productAddOnActiveGroupItemsRow' + index">
                          <div v-for="(subItem, subIndex) in item.items" :key="subIndex"
                            class="d-flex justify-content-between text-muted p-s">
                            <span class="p-s text-dark font-weight-normal m-0"
                              :id="'productAddOnActiveGroupItemName' + subIndex"> {{ subItem.name }}</span>
                            <span class="p-s text-dark font-weight-normal m-0"
                              :id="'productAddOnActiveGroupItemPrice' + subIndex">{{ subItem.price }}</span>
                          </div>
                        </div>
                      </div>
                    </CCol>
                  </CRow>
                </VueDraggable>
              </div>
            </tbody>
          </table>
          <!-- <CCard id="productAddOnActiveCard" style="background-color: #f6f6f6" class="adcard">
            <CCardBody id="productAddOnActiveBody">
              
              <div id="productAddOnActiveList" class="overflow-auto con-add" v-if="activeGroup.length > 0">
                <CRow id="productAddOnActiveGroupRow" v-for="(item, index) in activeGroup" :key="index">
                  <CCol :id="'productAddOnActiveGroupCol'+ index">
                    <CCard :id="'productAddOnActiveGroupCard'+ index" class="addon-body-active">
                      <CCardBody :id="'productAddOnActiveGroupBody'+ index">
                        <CRow :id="'productAddOnActiveGroupContentRow'+ index">
                          <CCol :id="'productAddOnActiveGroupImageCol'+ index" col="2">
                            <img
                              :id="'productAddOnActiveGroupImage'+ index"
                              src="/img/star_icon.png"
                              style="border-radius: 5px;"
                              class="img-fluid"
                            />
                          </CCol>
                          <CCol :id="'productAddOnActiveGroupInfoCol'+ index" col="10">
                            <tr :id="'productAddOnActiveGroupInfoRow'+ index">
                              <td :id="'productAddOnActiveGroupName' + index">
                                <p style="font-size: medium;">{{ item.groupActiveName }}</p>
                              </td>
                              <td :id="'productAddOnActiveGroupAction'+ index" class="text-right text-danger">
                                <img
                                  :id="'productAddOnActiveGroupActionIcon'+ index"
                                  src="/img/product/delete32.png"
                                  style="width: 25px;"
                                  v-if="isDeleteData"
                                  @click="confirmdeleteOptionGroup(item)"
                                  v-show="isEditData"
                                />
                              </td>
                            </tr>
                            <tr :id="'productAddOnActiveGroupDetailsRow'+ index">
                              <td :id="'productAddOnActiveGroupDetails'+ index" style="width: 70%; margin-bottom: 0rem;">
                                <CBadge :id="'productAddOnActiveGroupRequiredBadge'+ index" color="success" v-if="item.require">
                                  Required
                                </CBadge>
                                <CBadge :id="'productAddOnActiveGroupMinBadge'+ index" color="primary" v-if="item.minimum !== undefined">
                                  Min : <span>{{ item.minimum }}</span>
                                </CBadge>
                                <CBadge :id="'productAddOnActiveGroupMaxBadge'+ index" color="info" v-if="item.maximum !== undefined">
                                  Max : <span>{{ item.maximum }}</span>
                                </CBadge>
                              </td>
                              <td :id="'productAddOnActiveGroupTotals'+ index" class="text-right" style="margin-bottom: 0rem;">
                                {{ $t('totals') }} ({{ item.items.length }})
                              </td>
                            </tr>
                            <hr id="productAddOnActiveGroupDivider" class="hr-card-option" />
                            <tr
                              :id="'productAddOnActiveGroupItemsRow'+ index"
                              v-for="(subItem, subIndex) in item.items"
                              :key="subIndex"
                              style="border-top: 0px solid #ececec"
                            >
                              <td :id="'productAddOnActiveGroupItemName'+ subIndex" style="width: 90%">
                                <p class="p-s">
                                  <i class="fa-solid fa-circle" style="font-size: .3rem;"></i> {{ subItem.name }}
                                </p>
                              </td>
                              <td :id="'productAddOnActiveGroupItemPrice'+ subIndex" class="text-right">
                                <p class="p-s">{{ subItem.price }}</p>
                              </td>
                            </tr>
                          </CCol>
                        </CRow>
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
              </div>

              <div id="productAddOnNoActiveOptions" class="overflow-auto con-add" style="max-height: 500px" v-else>
                <slot name="no-items-view">
                  <div id="productAddOnNoActiveItemsMessage" class="text-center my-5">
                    <h4 style="color: #ced2d8;">{{ $t('noItem') }}</h4>
                  </div>
                </slot>
              </div>
            </CCardBody>
          </CCard> -->
        </div>
      </div>
      <CRow id="productAddOnModalRow">
        <CModal id="productAddOnModal" color="danger" :title="$t('confirmDeletGroup')"
          :show.sync="deleteOptionGroupModal" centered>
          <h4 id="productAddOnModalHeader" class="mt-4 mb-4 text-center">{{ $t('dialigDeleteGroup') }}</h4>
          <template #footer>
            <CRow id="productAddOnModalFooterRow" class="justify-content-around col-md-12">
              <CCol id="productAddOnModalFooterDeleteCol" col="4">
                <CButton id="productAddOnModalFooterDeleteButton" v-if="loadingDeleteButton === false"
                  @click="deleteOptionGroup" color="danger" block>
                  {{ $t('delete') }}
                </CButton>
                <CButton id="productAddOnModalFooterDeleteButtonLoading" v-else-if="loadingDeleteButton === true"
                  color="danger" block disabled>
                  <CSpinner color="white" size="sm" />
                </CButton>
              </CCol>
              <CCol id="productAddOnModalFooterCancelCol" col="4">
                <CButton id="productAddOnModalFooterCancelButton" v-if="loadingDeleteButton === false"
                  @click="deleteModal = false" color="light" block>
                  {{ $t('cancel') }}
                </CButton>
                <CButton id="productAddOnModalFooterCancelButtonLoading" v-else-if="loadingDeleteButton === true"
                  color="light" disabled block>
                  {{ $t('cancel') }}
                </CButton>
              </CCol>
            </CRow>
          </template>
        </CModal>
      </CRow>
    </div>
  </div>
</template>

<script>
import util from "@/util/util";
import local from "@/services/local";
import { mapGetters } from "vuex";
import permis from "@/util/permission";
import { VueDraggable } from 'vue-draggable-plus'

export default {
  components: {
    VueDraggable
  },
  data() {
    return {
      loading: true,
      loadingButton: true,
      SKU: [],
      optionGroupActive: [],
      optionGroupFields: [],
      productOption: [],
      optionGroupListItem: [],
      optionGroup: [],
      optionGroupdata: [],
      AddOptionGroupModal: false,
      deleteOptionGroupModal: false,
      loadingDeleteButton: false,
      itemDelete: {},
      autoScrollInterval: null,
      isDragging: false,
    };
  },
  computed: {
    ...mapGetters(["shops", "users", "date"]),

    uid() {
      let shop = this.shops.find((i) => i.objectId === this.shopObjectId);
      return shop.uid;
    },
    isEditData() {
      let path = '/product'
      const value = permis.findPermissionEdit('product', path)
      return value //&& this.editItem
    },
    dragDelay() {
        return this.isTouchDevice ? 400 : 0;
    },
    isTouchDevice() {
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        navigator.msMaxTouchPoints > 0
      );
    },
    shopObjectId: {
      get() {
        return this.$store.getters.shopObjectId;
      },
      set(newValue) {
        return this.$store.dispatch("setShop", newValue);
      },
    },
    optionGroupList() {
      let data = this.optionGroupdata;


      let objects = [];
      let dataActive = this.optionGroupActive;

      for (let i = 0; i < data.length; i++) {
        const object = data[i];
        let item = {};
        if (dataActive.some((active) => active.groupActiveObjectId === object.optionGroupObjectId)) {
          continue;
        }



        item = {
          name: object.optionGroupName,
          objectId: object.optionGroupObjectId,
          id: object.optionGroupId,
          selected: false, // Default value is false if condition is not met
          items: object.items,
          maximum: object.maximum,
          minimum: object.minimum,
          require: object.require,
        };


        objects.push(item);
      }
      return objects;
    },
    isDeleteData() {
      let path = "/product";
      return permis.findPermissionRemove("product", path);
    },
    activeGroup() {
      const object = [];
      //      maximum : this.productOption[i].maximum,
      // minimum : this.productOption[i].minimum,
      //         require :this.productOption[i].require,
      for (let i = 0; i < this.optionGroupActive.length; i++) {

        let item = {
          num: i + 1,
          groupActiveName: this.optionGroupActive[i].groupActiveName,
          groupActiveObjectId: this.optionGroupActive[i].groupActiveObjectId,
          groupActiveId: this.optionGroupActive[i].groupActiveId,
          action: "",
          activeObjectId: this.optionGroupActive[i].activeObjectId,
          activeId: this.optionGroupActive[i].activeId,
          items: this.optionGroupActive[i].items,
          maximum: this.optionGroupActive[i].maximum,
          minimum: this.optionGroupActive[i].minimum,
          require: this.optionGroupActive[i].require,
        };
        object.push(item);
      }

      return object;
    },
    productSKUdetail: {
      get() {
        return this.$store.getters.productSKUdetail
      },
      set() {
        return this.$store.getters.productSKUdetail
      }
    },
  },
  async created() {
    await this.getProductOptionActive();
    await this.getOptionGroup();
    this.shop = this.shops.find((i) => i.objectId === this.shop)

  },
  mounted() { },
  methods: {
    handleDragStart(event) {
      this.stopAutoScroll(event);
      document.body.style.userSelect = "none";
    },
    handleAutoScroll() {
      if (!this.isDragging) return; // 🟢 ถ้าไม่ได้ลาก => ไม่ทำงาน

      const container = this.$refs.draggable?.$el;
      const scrollThreshold = 50;
      const scrollSpeed = 5;

      if (!container) return;

      const { clientHeight, scrollHeight, scrollTop } = container;

      const nearBottom = scrollHeight - scrollTop - clientHeight < scrollThreshold;
      const nearTop = scrollTop < scrollThreshold;

      if (nearBottom) {
        this.startAutoScroll(container, "down", scrollSpeed);
      } else if (nearTop) {
        this.startAutoScroll(container, "up", scrollSpeed);
      } else {
        this.stopAutoScroll();
      }
    },
    startAutoScroll(container, direction, scrollSpeed) {
      if (this.autoScrollInterval) return;

      this.autoScrollInterval = setInterval(() => {
        if (direction === "down") {
          container.scrollTop += scrollSpeed;
        } else {
          container.scrollTop -= scrollSpeed;
        }
      }, 50);
    },
    stopAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
      document.body.style.userSelect = "";
    },

    async onDragEnd() {
      try {
        await this.syncOptionGroupOrderIndex();
      } catch (error) {
        console.error("⚠️ Failed to sync order after drag:", error);
      }
    },
    confirmdeleteOptionGroup(item) {
      this.deleteOptionGroupModal = true
      this.itemDelete = item
    },
    async deleteOptionGroup() {
      try {
        this.shop = this.shops.find((i) => i.objectId === this.shopObjectId);
        const uid = `${localStorage.getItem('shopsUid')}`;
        const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId) };

        const data = [{
          objectId: this.itemDelete.activeObjectId,
          id: this.itemDelete.activeObjectId,
          optionGroup: {
            objectId: this.itemDelete.groupActiveObjectId,
            name: this.itemDelete.groupActiveName,
            id: this.itemDelete.groupActiveId,
          },
          updated_at: new Date(),
          deleted_at: new Date(),
          productSKU: {
            SKUName: this.productSKUdetail.SKUName,
            SKUPrice: this.productSKUdetail.SKUPrice,
            id: this.productSKUdetail.id,
            objectId: this.productSKUdetail.objectId,
          },
          uid,
          shop: {
            objectId: this.shop.objectId,
            id: this.shop.id,
            branchName: this.shop.branchName,
          },
        }];

        this.loading = true;
        this.loadingDeleteButton = true;

        await local.post(`/api/V1.0/${uid}/option/activegroup/update`, data, { headers });

        await this.getProductOptionActive();
        // await this.getOptionGroup();
        await this.syncOptionGroupOrderIndex();

        this.loading = false;
        this.loadingDeleteButton = false;
        this.deleteOptionGroupModal = false;

      } catch (error) {
        console.error('[deleteOptionGroup] failed:', error);
        this.loadingDeleteButton = false;
      }
    },
    onSelectedAutoCompleteEvent(item) {
      if (item.selected == true) {
        this.selectedItems.push(
          {
            name: item.name,
            objectId: item.objectId,
            id: item.id
          }
        );
      } else {
        // ถ้า item ถูกยกเลิกการเลือก
        this.selectedItems = this.selectedItems.filter(
          (x) => x.objectId !== item.objectId
        );
      }
    },
    async syncOptionGroupOrderIndex() {
      try {
        const uid = this.uid;
        const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};
        this.shop = this.shops.find((i) => i.objectId === this.shopObjectId);

        const data = this.optionGroupActive.map((item, index) => ({
          objectId: item.activeObjectId,
          id: item.activeId,
          orderIndex: index,
          optionGroup: {
            objectId: item.groupActiveObjectId,
            name: item.groupActiveName,
            id: item.groupActiveId,
            updated_at: new Date(),
          },
          productSKU: {
            SKUName: this.productSKUdetail.SKUName,
            SKUPrice: this.productSKUdetail.SKUPrice,
            id: this.productSKUdetail.id,
            objectId: this.productSKUdetail.objectId,
          },
          uid: uid,
          updated_at: new Date(),
          shop: {
            objectId: this.shop.objectId,
            id: this.shop.id,
            branchName: this.shop.branchName,
          },
        }));

        await local.post(`/api/V1.0/${uid}/option/activegroup/update`, data, { headers });


        await this.getProductOptionActive();
        // await this.getOptionGroup();

      } catch (error) {
        console.error("❌ Failed to sync orderIndex:", error);
      }
    },

    async getProductOptionActive() {
      try {
        this.loadingButton = false;

        const uid = this.uid;
        const skuObjectId = this.$route.params.productSKUObjectId;
        const params = { 
          skuObjectId ,
          page: 1,
          limit: 100,
        };
        const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};

        const res = await local.get(`/api/v1.0/${uid}/productsku/getproductoption`, { params ,headers});

        this.optionGroupActive = [];

        const rawOptions = res.data.data || [];
        this.productOption = Array.isArray(rawOptions)
          ? rawOptions.filter(item => item.deleted_at === undefined)
          : [];

        for (let i = 0; i < this.productOption.length; i++) {
          const group = this.productOption[i].OptionGroup;
          // safety check
          if (!group || !Array.isArray(group.items)) continue;

          const items = group.items.map(item => ({
            name: item.optionItem?.name ?? '',
            price: item.optionItem?.price ?? 0,
          }));
          this.optionGroupActive.push({
            num: i + 1,
            orderIndex: this.productOption[i].orderIndex,
            groupActiveName: group.name ?? 'Unnamed',
            groupActiveObjectId: group.objectId,
            groupActiveId: group.id,
            activeObjectId: this.productOption[i].objectId,
            activeId: this.productOption[i].id,
            maximum: group.maximum ?? null,
            minimum: group.minimum !== undefined && group.minimum !== null
              ? group.minimum
              : group.require
                ? 1
                : null,
            require: group.require ?? false,
            items,
          });
          this.optionGroupActive.sort((a, b) => a.orderIndex - b.orderIndex);
        }

        this.loading = true;
      } catch (error) {
        console.error('[getProductOptionActive] Failed:', error);
      }
    },

    async getOptionGroup() {
      try {
        this.loading = false;
        const uid = this.uid;
        const shopObjectId = this.shopObjectId;
        let params = { 
          shopObjectId: shopObjectId ,
          page: 1,
          limit: 100,
        };
        const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};
        this.optionGroupdata = [];
        await local
          .get("/api/V1.0/" + uid + "/option/group/get", { params ,headers})
          .then((res) => {
            if (res.data.data.deleted_at !== undefined) {
              this.optionGroup = res.data.data.filter(
                (item) => item.deleted_at === undefined
              );
            } else {
              this.optionGroup = res.data.data;
            }

            for (let i = 0; i < this.optionGroup.length; i++) {
              let maximum = 0
              let minimum = 0
              if (this.optionGroup[i].maximum !== undefined) {
                maximum = this.optionGroup[i].maximum
              }

              if (this.optionGroup[i].minimum !== undefined) {
                minimum = this.optionGroup[i].minimum
              }

              let item = {
                num: i + 1,
                optionGroupName: this.optionGroup[i].name,
                optionGroupObjectId: this.optionGroup[i].objectId,
                optionGroupId: this.optionGroup[i].id,
                maximum: maximum,
                minimum: minimum,
                require: this.optionGroup[i].require,
                items: this.optionGroup[i].items,
              };
              this.optionGroupdata.push(item);
            }

            this.loadingButton = true;
          });
      } catch (error) {
        console.log(error);
      }
    },
    async onCheckboxChange(item, index) {
      let option = {
        name: item.name,
        objectId: item.objectId,
        id: item.id,
        updated_at: new Date(),
      };

      let maxOrderIndex = 0;
      if (this.optionGroupActive.length > 0) {
        maxOrderIndex = Math.max(...this.optionGroupActive.map(o => o.orderIndex || 0));
        maxOrderIndex = maxOrderIndex + 1; // Increment to ensure new item has a unique order index
      }

      try {
        this.shop = this.shops.find((i) => i.objectId === this.shopObjectId);
        const uid = localStorage.getItem('shopsUid');

        const dataSelectd = {
          optionGroup: option,
          productSKU: {
            SKUName: this.productSKUdetail.SKUName,
            SKUPrice: this.productSKUdetail.SKUPrice,
            id: this.productSKUdetail.id,
            objectId: this.productSKUdetail.objectId,
          },
          uid: uid,
          updated_at: new Date(),
          shop: {
            objectId: this.shop.objectId,
            id: this.shop.id,
            branchName: this.shop.branchName,
          },
          orderIndex: maxOrderIndex 
        };

        const headers = { shopObjectId: util.sanitizeShopObjectId(this.shopObjectId)};
        this.loading = false;

        await local.post(`/api/V1.0/${uid}/option/activegroup/update`, [dataSelectd], { headers });

        // ⏳ optional delay
        await new Promise(resolve => setTimeout(resolve, 500));

        await this.getProductOptionActive();
        // await this.getOptionGroup();
        await this.syncOptionGroupOrderIndex();

        this.loading = true;
        this.loadingButtonValidatePRU = false;

      } catch (error) {
        console.error('[onCheckboxChange] failed:', error);
      }
    }

  },
};
</script>
<style>
.add-on-card {

  border-color: #29b289;
}

.adcard {
  /* min-height: 600px;
    max-height: 600px; */
}

.hr-card-option {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px;
  border-top: 1px solid rgba(0, 0, 21, 0.2);
}

.p-s {
  margin-bottom: 0rem;
  font-size: smaller;
}

.addon-body {
  border: 1px solid #29b289;
  border-radius: 5px;
  padding: 0rem;
  /* min-height: 120px; */
}

.addon-body-active {
  border: 2px solid #F6F6F6;
  box-shadow: rgba(0, 0, 21, 0.075) 0px 0.125rem 0.25rem;
  border-radius: 5px;
  padding: 0rem;
  /* min-height: 120px; */
}


.con-add {
  min-height: 500px;
  max-height: 500px;
}

@media(min-width: 1400px) {
  .con-add {
    min-height: 650px;
    max-height: 650px;
  }

}

@media(min-width: 1200px) {
  .con-add {
    min-height: 650px;
    max-height: 650px;
  }
}

@media(min-width: 1000px) {
  .con-add {
    min-height: 550px;
    max-height: 550px;
  }

}

.aohover:hover {
  -webkit-box-shadow: 0 6px 10px 0 rgb(0 0 0 / 16%);
  box-shadow: 0 6px 10px 0 rgb(0 0 0 / 16%);
  cursor: pointer;
}

.left-panel {
  width: 50%;
  padding: 1rem;
  border-right: 1px solid #eee;
}

.right-panel {
  width: 50%;
  padding: 1rem;
  background-color: #f9f9f9;
}

.option-card,
.active-option-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.option-items div {
  padding: 0.1rem 0;
  font-size: 14px;
}
.disabled-card {
  cursor: not-allowed;
  opacity: 0.5;
  pointer-events: none;
}
</style>
